/**
 * A delivery order must have a destination, otherwise the printed накладная
 * (invoice) shows neither a recipient nor an address — the operator "sees the
 * order but not who it is addressed to".
 *
 * A destination is present when EITHER a delivery address was typed/auto-filled,
 * OR a client with a saved address is attached (the address is auto-copied from
 * the client, but the effect that does so may not have run yet at submit time,
 * so we accept the client's address directly as a fallback).
 *
 * Non-delivery orders never require a destination.
 */
export function deliveryHasDestination({ delivery, deliveryAddress, client }) {
  if (!delivery) return true
  const address = typeof deliveryAddress === 'string' ? deliveryAddress.trim() : ''
  const clientAddress = typeof client?.address === 'string'
    ? client.address.trim()
    : (client?.address != null ? String(client.address).trim() : '')
  return Boolean(address || clientAddress)
}
